import React, { Component } from 'react';

import {
  Wrapper,
  Embed,
  Mask,
} from './style';

class InstagramEmbed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 0,
      width: 0,
    }
  }

  resize = () => {
    if (!this.wrapper || !this.embed) return;

    const parent = this.wrapper.parentNode;
    const parentRect = parent.getBoundingClientRect();
    const embedRect = this.embed.getBoundingClientRect();

    let height = 0;
    let width = 0;

    if (embedRect.height / embedRect.width > parentRect.height / parentRect.width) {
      height = parentRect.height;
      width = embedRect.width / embedRect.height * height;
    } else {
      width = parentRect.width;
      height = embedRect.height / embedRect.width * width;
    }

    this.setState({ height, width });
  }

  render() {
    const { fullWidth } = this.props;
    const { height, width } = this.state;

    const style = fullWidth ? {
        height: 'auto',
        width: '100%',
      } : height > 0 && width > 0 ? {
        height,
        width
      } : {
        opacity: 0,
      };

    return (
      <Wrapper
        innerRef={(el) => {
          if (!this.wrapper) {
            this.wrapper = el;
            // this.resize();
          }
        }}
      >
        <Embed
          style={style}
          innerRef={(el) => {
            if (!this.embed) {
              this.embed = el;
              // this.resize();
            }
          }}
          dangerouslySetInnerHTML={{
            __html: this.props.code
          }}
        />
        <Mask />
      </Wrapper>
    );
  }
}

export default InstagramEmbed;



// WEBPACK FOOTER //
// ./src/components/InstagramEmbed/index.js